import React, { useEffect, useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as types from "../../../constants/actionTypes";
import QuickActionBar from "./QuickActionBar";
import GetCareTile from "./GetCareTile";
import useCollapsedBanner from "./hooks/useCollapsedBanner";
import useBannerOffset from "./hooks/useBannerOffset";
import useElementHeight from "../../common/hooks/useElementHeight";

const GetCareBanner = ({
    showGetCareTileToolTip,
    openActionBarToolTip,
    isMobile,
    isDesktop,
    disabled,
    dashBoardDetails,
    isShowAllUsers,
    onBoardingToolTipState,
    updateonBoardingToolTipState,
    showDependentProxyForm,
    isProxyFound
}) => {

    const bannerRef = useRef(null);
    let bannerHeight = useElementHeight(bannerRef);
    let bannerScrollOffset = useBannerOffset(bannerRef);
    let { collapseBanner, minimizeBanner } = useCollapsedBanner(bannerHeight, bannerScrollOffset);

    return (
        <div className={`row get-care-banner`} ref={bannerRef}>
            <div className="col-12">
                <div className={`row get-care-banner-content--${collapseBanner ? "collapsed" : "default"} ${minimizeBanner ? "get-care-banner-content--minimize" : ""}`}>
                    <div className={`col-12 maxWidth-content ${collapseBanner ? 'main-menu-offset__margin-left' : ''}`}>
                        <div className={`row get-care-banner-sections-container`}>
                            <div className={`get-care-banner__get-care-tile ${collapseBanner ? isMobile ? 'col-4' : 'col-3' : 'col-12'}`}>
                                <GetCareTile
                                    isMobile={isMobile}
                                    collapsed={collapseBanner}
                                    showGetCareTileToolTip={showGetCareTileToolTip}
                                    openActionBarToolTip={openActionBarToolTip}
                                    disabled={disabled}
                                />
                            </div>
                            <div className={`get-care-banner__quick-action-bar ${collapseBanner ? isMobile?'col-8':'col' : 'col-12'}`}>
                                <QuickActionBar
                                    disabled={disabled}
                                    dashBoardDetails={dashBoardDetails}
                                    isMobile={isMobile}
                                    isDesktop={isDesktop}
                                    isShowAllUsers={isShowAllUsers}
                                    showDependentProxyForm={showDependentProxyForm}
                                    isProxyFound={isProxyFound}
                                    onBoardingToolTipState={onBoardingToolTipState}
                                    updateonBoardingToolTipState={updateonBoardingToolTipState}
                                    collapsed={collapseBanner}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        hasMyChart: state.domain.hm,
        showDependentProxyForm: state.session.showDependentProxyForm,
        isProxyFound: state.memberships.isProxyFound
    };
};

export default withRouter(connect(mapStateToProps, null)(GetCareBanner));
